import { IconPropsType } from '..';

export const PopularGamesIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.8547 8.25607L15.1924 2.76321C15.034 2.52571 14.7417 2.38464 14.4916 2.38464H5.44499C5.19497 2.38464 4.93438 2.52572 4.77592 2.76179L1.14528 8.25464C0.923006 8.58668 0.959312 9.03036 1.23001 9.32214L9.36812 18.115C9.5299 18.2882 9.75175 18.3846 9.98417 18.3846C10.2166 18.3846 10.4398 18.287 10.5994 18.1151L18.7692 9.32225C19.0414 9.03107 19.0766 8.58821 18.8547 8.25607ZM14.4388 4.69143L16.6785 8.09893H11.7449L14.4388 4.69143ZM9.98417 7.63107L7.22334 4.09893H12.7415L9.98417 7.63107ZM5.52951 4.69143L8.19174 8.09893H3.25957L5.52951 4.69143ZM9.98417 16.2775L3.97725 9.81322H15.9925L9.98417 16.2775Z" />
    </svg>
  );
};
